import qualityEventsHelpers from '../quality-events.helpers';

type SchoolWishlistEventArgs = { schoolId: number | null; materialId: number; searchRequestId?: string };

export const SCHOOL_WISHLIST_QUALITY_EVENTS = {
    addToSchoolWishlist({ schoolId, materialId, searchRequestId }: SchoolWishlistEventArgs) {
        qualityEventsHelpers.track({
            type: 'add_to_school_wishlist',
            extra: JSON.stringify({ school_id: schoolId ?? null, materialId, search_request_id: searchRequestId })
        });
    },
    removeFromSchoolWishlist({ schoolId, materialId, searchRequestId }: SchoolWishlistEventArgs) {
        qualityEventsHelpers.track({
            type: 'remove_from_school_wishlist',
            extra: JSON.stringify({ school_id: schoolId ?? null, materialId, search_request_id: searchRequestId })
        });
    },
    voteMaterial({ schoolId, materialId }: SchoolWishlistEventArgs) {
        qualityEventsHelpers.track({
            type: 'vote_material_school_wishlist',
            extra: JSON.stringify({ school_id: schoolId ?? null, materialId })
        });
    },
    unvoteMaterial({ schoolId, materialId }: SchoolWishlistEventArgs) {
        qualityEventsHelpers.track({
            type: 'unvote_material_school_wishlist',
            extra: JSON.stringify({ school_id: schoolId ?? null, materialId })
        });
    }
};
